/** Fecha de emisión de invoice = fecha de embarque (sin default a hoy). */
export function resolveInvoiceIssueDate(inv, pl = null) {
  const f = inv?.datos_formulario || {};
  const candidates = [f.fechaEmbarque, pl?.fecha_embarque, inv?.fecha_invoice, f.fechaInvoice];
  for (const c of candidates) {
    if (c == null || c === '') continue;
    const s = String(c).trim().slice(0, 10);
    if (s) return s;
  }
  return '';
}

export function resolveInvoiceIssueDateFromForm(f) {
  const s = String(f?.fechaEmbarque || f?.fechaInvoice || '').trim().slice(0, 10);
  return s || '';
}

/** Fecha en encabezado PDF/Excel invoice; sin valor → guión. */
export function invoiceIssueDateText(isoDate, fmtLongEn) {
  const raw = isoDate == null ? '' : String(isoDate).trim();
  if (!raw) return '—';
  const formatted = fmtLongEn(raw);
  return formatted || '—';
}
